/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductShowcaseLayout = {
    CAROUSEL: 'CAROUSEL',
    GRID: 'GRID',
    SINGLE: 'SINGLE'
} as const;
export type ProductShowcaseLayout = typeof ProductShowcaseLayout[keyof typeof ProductShowcaseLayout];


export function instanceOfProductShowcaseLayout(value: any): boolean {
    for (const key in ProductShowcaseLayout) {
        if (Object.prototype.hasOwnProperty.call(ProductShowcaseLayout, key)) {
            if (ProductShowcaseLayout[key as keyof typeof ProductShowcaseLayout] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductShowcaseLayoutFromJSON(json: any): ProductShowcaseLayout {
    return ProductShowcaseLayoutFromJSONTyped(json, false);
}

export function ProductShowcaseLayoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductShowcaseLayout {
    return json as ProductShowcaseLayout;
}

export function ProductShowcaseLayoutToJSON(value?: ProductShowcaseLayout | null): any {
    return value as any;
}

export function ProductShowcaseLayoutToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductShowcaseLayout {
    return value as ProductShowcaseLayout;
}

